
<template>
  <el-select class="kye-date-picker2_year-select"
    v-model="curYear"
    :popper-append-to-body="false"
    @change="handleYearClick">
    <el-option
      v-for="item in yearList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
  import { arrayFindIndex } from 'element-ui/lib/utils/util'
  import { generateYearData } from '../utils'
  export default {
    props: {
      date: {},
      startDate: {},
      endDate: {}
    },
    computed: {
      yearList() {
        return generateYearData(this.startDate, this.endDate, this.date)
      }
    },
    watch: {
      date: {
        handler() {
          const _curYear = this.date.getFullYear()
          if (_curYear !== this.curYear) {
            this.curYear = _curYear
          }
        },
        immediate: true
      }
    },
    data() {
      return {
        curYear: null
      }
    },
    methods: {
      handleYearClick(year) {
        if (this.selectionMode === 'years') {
          const value = this.value || []
          const idx = arrayFindIndex(value, date => date.getFullYear() === Number(year))
          const newValue = idx > -1
            ? [...value.slice(0, idx), ...value.slice(idx + 1)]
            : [...value, new Date(year)]
          this.$emit('pick', newValue)
        } else {
          this.$emit('pick', Number(year))
        }
      }
    }
  }
</script>

<style lang="scss">
.ky-erp .kye-date-picker2{
  &_year-select{
    width: 62px !important;
    .el-input{
      .el-input__inner{
        padding-right: 18px !important;
      }
      .el-input__suffix{
        display: flex;
        align-items: center;
        right: 8px;
        .el-icon-arrow-up {
          width: 8px;
          height: 5px;
          background-image: url("../images/arrow-up.png");
          background-size: 8px 5px;
          display: block;
          background-repeat: no-repeat;
          transform: rotateZ(0deg) !important;
          &::before{
            content: "" !important;
          }
        }
      }
    }
    .el-select-dropdown__wrap{
      max-height: 174px !important;
      .el-select-dropdown__item{
        padding-left: 8px !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-date-picker2/src/basic/year-select.vue